import React, {useRef, useState} from 'react';
import { Grid, Box } from '@material-ui/core';
import { withTranslation } from 'react-i18next'
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    root: {
      display: 'flex',
    },
  }));

const Product = ({ t }) => {
    const classes = useStyles();

  return (
    <div className="relative">
      <Grid container direction="row">
        <Grid container xs={12} md={12} className='text-center'>
            <h1 className='w-100 font-size-24 mb-30'>{t('SDKsupport.SDKsupportTitle')}</h1>
            <div className='d-flex justify-content-between sdkImg'>
                <img src='/icon-sdk/js-sdk.png' style={{width:'13%'}}/>
                <img src='/icon-sdk/go-sdk.png' style={{width:'13%'}}/>
                <img src='/icon-sdk/python-sdk.png' style={{width:'13%'}}/>
                <img src='/icon-sdk/ruby-sdk.png' style={{width:'13%'}}/>
                <img src='/icon-sdk/react-sdk.png' style={{width:'13%'}}/>
                <img src='/icon-sdk/php-sdk.png' style={{width:'13%'}}/>
            </div>
        </Grid>
      </Grid>
  </div>
  );
}
export default withTranslation()(Product);